// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2202b16f","455":"2c207037"}[chunkId] + ".chunk.js";
};